import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import useRetrieveDocumentationGraphQL from '../../../../hooks/vp/dokumentasjon';
import Loader from '../../../loader';
import CustomAlert from '../../../customAlert';
import dokuCSS from './dokumentasjon.module.css';
import FormModal from '../../../formModal';
import AddDocumentationForm from '../../../addDocumentationForm';
import DocumentationHistory from '../../../dokumentasjonsHistorie';
import Checklist from '../../../checklist';
import EditOrderedProductForm from '../../../editOrderedProductForm';
import Modal from 'react-bootstrap/Modal';
import { axiosAuthFetch } from '../../../../helpers/apiActions/authFetch';
import { API_BASE_URL } from '../../../../constants';

export default function VpDokumentasjonsSide() {

    const {id} = useParams();

    const {documentation, isLoading, isError} = useRetrieveDocumentationGraphQL(id);

    const [isOpen, setIsOpen] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [showServiceModal, setShowServiceModal] = useState(false);
    const handleOpenService = () => setShowServiceModal(true);
    const handleCloseService = () => setShowServiceModal(false);

    // const formatDate = (date) => {
    //     return new Date(date).toLocaleDateString('nb-NO');
    // }

    const formatDate = (date) => {
        if (!date) return '';
        const options = { year: 'numeric', month: 'long' }; // Specify the format
        return new Date(date).toLocaleDateString('nb-NO', options);
    };

    if(isLoading || !documentation) {
        return (
            <Loader />
        )
    }
    if(isError) {
        return (
            <CustomAlert message="Oida, her gikk noe galt! Vennligst prøv igjen!" />
        )
    }

    //console.log('ordered-product documentation', documentation);
    
    if(documentation) {

        const product = documentation.orderedProduct.data.attributes.product.data.attributes;
        const {serial_number} = documentation.orderedProduct.data.attributes;
        // const {date_performed, next_service_date} = documentation.orderedProduct.data.attributes.executed_services.data[0].attributes.service_info;
        // const serviceForm = documentation.orderedProduct.data.attributes.product.data.attributes.service_form;
        let serviceChecks = [];
        let date_performed = '';
        let date_delivered = '';
        let next_service_date = '';
        let fID = '';
        // const dateDelivered = documentation.orderedProduct.data.attributes.product_delivered_date;
        // const dateToService = ()
        // const dateDelivered = new Date(documentation.orderedProduct.data.attributes.product_delivered_date);
        // const nextYear = dateDelivered.getFullYear() + 1;
        // const month = (dateDelivered.getMonth() + 1).toString().padStart(2, '0'); // Måned er null-indeksert, så vi legger til 1
        // const dateToService = `${month}.${nextYear}`;
        // console.log(dateDelivered, dateToService);

        // const formatMonthYear = (date) => {
        //     const year = date.getFullYear();
        //     const month = (date.getMonth() + 1).toString().padStart(2, '0');
        //     return `${month}.${year}`;
        // };
        
        const dateDelivered = new Date(documentation.orderedProduct.data.attributes.product_delivered_date);
        const dateToService = new Date(dateDelivered);
        const firstDelivery = new Date(documentation.orderedProduct.data.attributes.first_time_delivery);
        dateToService.setFullYear(dateDelivered.getFullYear() + 1);
        
        const formattedDateDelivered = formatDate(dateDelivered);
        const formattedDateToService = formatDate(dateToService);
        const formattedFirstDelivery = formatDate(firstDelivery);

        console.log(dateDelivered, formattedFirstDelivery);
        console.log(formattedDateDelivered); // Forventet format "MM.ÅÅÅÅ", f.eks. "05.2024"
        console.log(formattedDateToService); // Forventet format "MM.ÅÅÅÅ", f.eks. "05.2025"


        //console.log(product);

        if (product.service_form) {
            const serviceForm = product.service_form;
            console.log('Service form:', serviceForm);
        
            // Sjekk om serviceForm har data
            if (serviceForm.data) {
              console.log('Service form data:', serviceForm.data);
        
              // Sjekk om serviceForm.data har attributes
              if (serviceForm.data.attributes) {
                console.log('Service form data attributes:', serviceForm.data.attributes);
        
                // Sjekk om serviceForm.data.attributes har service_checks
                if (serviceForm.data.attributes.service_checks) {
                  console.log('Service checks:', serviceForm.data.attributes.service_checks);
        
                  // Sett serviceChecks
                  serviceChecks = serviceForm.data.attributes.service_checks.data;
                  console.log('Service checks data:', serviceChecks);
        
                  // Sjekk om serviceForm.data har id
                  fID = serviceForm.data.id;
                  console.log('Form ID:', fID);
                } else {
                  console.log('Service checks not found');
                }
              } else {
                console.log('Service form data attributes not found');
              }
            } else {
              console.log('Service form data not found');
            }
          } else {
            console.log('Service form not available');
          }

        // if(documentation.orderedProduct.data.attributes.product.data.attributes.service_form.length > 0 ){
        //     const serviceForm = documentation.orderedProduct.data.attributes.product.data.attributes.service_form;
        //     serviceChecks = serviceForm.data.attributes.service_checks.data;
        //     console.log(serviceChecks);
        //     if(serviceForm.data > 0) {
        //         fID = serviceForm.data.id;
        //     }
        // }
        

        const customerData = documentation.orderedProduct.data.attributes.customer.data;

        

    if (documentation.orderedProduct.data.attributes.executed_services.data.length > 0) {
        const service_info = documentation.orderedProduct.data.attributes.executed_services.data[0].attributes.service_info;
        if (service_info) {
            date_performed = service_info.date_performed || '';
            next_service_date = service_info.next_service_date || '';
        }
    }

    const currentYear = new Date().getFullYear();
    const lastServiceYear = new Date(date_performed).getFullYear();
    const servicePerformedThisYear = lastServiceYear === currentYear;

    const handleEditButtonClick = () => {
        setIsEditOpen(!isEditOpen);
    }

    const handleSaveNewAttributes = async (newAttributes) => {
        try {
            const response = await axiosAuthFetch(`${API_BASE_URL}/ordered-products/${id}`, {
                data: {
                    first_time_delivery: newAttributes.date_delivered,
                    date_performed: newAttributes.date_performed,
                    next_service_date: newAttributes.next_service_date
                }
            }, 'PUT');
            setIsEditOpen(false);
            console.log(response);
            alert('Informasjon oppdatert!');
            window.location.reload();
        } catch (error) {
            console.error(error);
        }
        console.log('Save new attributes:', newAttributes);
        setIsEditOpen(false);
    };

    return(
        <div className={dokuCSS.container}>
            <div className={dokuCSS.container2}>
                <div className={dokuCSS.imageContainer} 
                    style={{
                        backgroundImage: `url(${product?.image?.data?.attributes?.url})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'contain',
                        width: '20em',
                        height: '20em',
                    }}
                />
                <div className={dokuCSS.dokuHeading}>
                    DOKUMENTASJON
                </div>
                <div className={dokuCSS.container4}>
                    <div className={dokuCSS.ddTrigger} onClick={()=>{setIsOpen(!isOpen)}}>
                        SERVICE-HISTORIKK
                    </div>
                    {documentation && (
                        <div className={`${dokuCSS.ddContent} ${isOpen ? dokuCSS.active : ''}`}>
                            <div className={dokuCSS.ddChild}>
                                <DocumentationHistory
                                    documentation={documentation}
                                />
                            </div>
                        </div>
                    )}
                </div>
                <div className={dokuCSS.leggTilContainer}>
                    <div>LEGG TIL HISTORIKK/SERVICE</div>
                    <div className={dokuCSS.leggTilContainer2}>
                        <div className={dokuCSS.leggTilContainer3}>
                            <FormModal 
                                buttonTitle="Last opp dokumentasjon"
                                openButtonClass="button"
                                closeButtonClass="button"
                                body={<AddDocumentationForm />}
                            />
                        </div>
                        <div className={dokuCSS.leggTilContainer4}>
                            {servicePerformedThisYear ? ( <div className={dokuCSS.alreadyButton}> Service utført i år</div>) :(
                            <>
                            <div onClick={handleOpenService} className="button btn btn-primary" variant="primary">
                                Kjør service
                            </div>
        
                            <Modal show={showServiceModal} size="lg" onHide={handleCloseService} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Kjør service</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Checklist
                                        checks={serviceChecks}
                                        formID={fID}
                                        orderedProductId={id}
                                        customerData={customerData}
                                    />
                                </Modal.Body>
                                <Modal.Footer>
                                    <button className="button btn btn-primary" onClick={handleCloseService}>
                                        Lukk
                                    </button>
                                </Modal.Footer>
                            </Modal>
                        </>
                        )}
                        </div>
                    </div>
                </div>
            </div>
            <div className={dokuCSS.container3}>
                <div className={dokuCSS.produktNavn}>
                    {product.name}
                </div>
                <div className={dokuCSS.supplierNavn}>
                    fra {product.supplier.data.attributes.name}
                </div>
                <div className={dokuCSS.editButton} onClick={handleEditButtonClick}>
                        Rediger
                    </div>
                <div className={dokuCSS.serviceInfoContainer}>
                    <div className={dokuCSS.subHeading}>
                        Serienummer: {serial_number ? serial_number : 'N/A'}
                    </div>
                    <div className={dokuCSS.subHeading}>
                        Produkt levert: {date_delivered ? `${formatDate(date_delivered)}` : formattedFirstDelivery}
                    </div>
                    <div className={dokuCSS.subHeading}>
                        Siste service utført: {date_performed ? `${formatDate(date_performed)}` : formattedDateDelivered}
                    </div>
                    <div className={dokuCSS.subHeading}>
                        Neste planlagte service: estimert {next_service_date ? `${formatDate(next_service_date)}` : formattedDateToService }
                    </div>
                    
                </div>
            </div>
            <Modal show={isEditOpen} onHide={() => setIsEditOpen(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Rediger Produkt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <EditOrderedProductForm 
                        currentAttributes={{ date_delivered: formattedFirstDelivery }}
                        onSave={handleSaveNewAttributes}
                        onClose={() => setIsEditOpen(false)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <div className={dokuCSS.closeButton} onClick={() => setIsEditOpen(false)}>Lukk</div>
                </Modal.Footer>
            </Modal>
        </div>
        )
    }
}